import { sitApi } from './sitApiClient';

export async function listAllowlist() {
  const { data } = await sitApi.get('/allowlist');
  return data.entries ?? [];
}

export async function createAllowlistEntry(entry) {
  const { data } = await sitApi.post('/allowlist', entry);
  return data;
}

export async function deleteAllowlistEntry(did) {
  await sitApi.delete(`/allowlist/${encodeURIComponent(did)}`);
}
